import LinkCta from './components/linkCta'

export { LinkCta }
